import React from 'react';
import PropTypes from 'prop-types';
import { StateLabel } from '@common/components';

export const COLOR_STYLE_MAP = {
  rejected: 'coral',
  expired: 'midnight-lighter',
  confirmed: 'meadow',
  claimed: 'sun-darker',
};

export function WorksShiftState({ state }) {
  return <StateLabel state={state} color={COLOR_STYLE_MAP[state]} />;
}

WorksShiftState.propTypes = {
  state: PropTypes.string.isRequired,
};
